function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLuxury = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.844,2.072C10.196,1.596 10.758,1.307 11.352,1.307L30.102,1.307C30.696,1.307 31.258,1.588 31.61,2.072L40.36,13.947C40.891,14.666 40.836,15.658 40.243,16.322L22.118,36.322C21.758,36.713 21.258,36.94 20.727,36.94C20.196,36.94 19.696,36.713 19.336,36.322L1.211,16.322C0.61,15.658 0.563,14.666 1.094,13.947L9.844,2.072ZM12.852,5.182C12.594,5.377 12.524,5.729 12.688,6.002L17.172,13.471L5.672,14.432C5.352,14.455 5.102,14.729 5.102,15.057C5.102,15.385 5.352,15.65 5.672,15.682L20.672,16.932L20.774,16.932L35.774,15.682C36.094,15.658 36.344,15.385 36.344,15.057C36.344,14.729 36.094,14.463 35.774,14.432L24.282,13.479L28.766,6.01C28.93,5.736 28.86,5.377 28.602,5.189C28.344,5.002 27.985,5.033 27.766,5.268L20.727,12.885L13.688,5.26C13.469,5.025 13.11,4.994 12.852,5.182Z",
    style: {
      fill: "rgb(0,101,157)",
      fillRule: "nonzero"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLuxury);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/luxury.9026f891a4aa64713f3930bea6287c79.svg";